import React, { forwardRef, memo } from 'react'

const EadIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="47.6"
      height="48.3"
      viewBox="0 0 47.6 48.3"
      fill="none"
      {...props}>
      <circle cx={23.8} cy={24.283} r={23.8} fill="#78BE20" />
      <g
        stroke="#fff"
        strokeWidth={2.259}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none">
        <path d="m30.666 25.268-6.851 6.851a1.85 1.85 0 0 1-2.614 0l-7.266-7.266a1.85 1.85 0 0 1 0-2.614l8.224-8.224 9.91 9.91-1.06.687Z" />
        <path d="M23.457 24.97a1.716 1.716 0 1 0 0-3.433 1.716 1.716 0 0 0 0 3.433Z" />
        <path d="m22.243 22.04-5.996-5.995" />
        <path d="M34.098 31.149c0 .364-.145.713-.402.971a1.372 1.372 0 0 1-1.971 0c-.257-.258-.402-.607-.402-.971 0-1.373 1.373-3.433 1.373-3.433s1.372 2.06 1.372 3.433Z" />
      </g>
    </svg>
  )
)

EadIcon.displayName = 'EadIcon'

export default memo(EadIcon)
